import committee from '$modules/committee/routes'
import personCommittee from '$modules/personCommittee/routes'
import dietOption from '$modules/dietOption/routes'
import personDietOption from '$modules/personDietOption/routes'
import emailSubscription from '$modules/emailSubscription/routes'
import personEmailSubscription from '$modules/personEmailSubscription/routes'
import grouping from '$modules/grouping/routes'
import personEvent from '$modules/personEvent/routes'
import personGrouping from '$modules/personGrouping/routes'

export default [
  {
    path: 'person',
    meta: {
      title: 'People',
      auth: ['Admin', 'Super Admin'],
      hidden: false,
      icon: 'people'
    },
    component: () => import('./pages/index'),
    redirect: 'person/list',
    children: [
      {
        path: 'list',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'List',
          resource: 'person',
          icon: 'playlist_add_check',
          hidden: false
        },
        component: () => import('./pages/list')
      },
      {
        path: 'edit/:id',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Edit',
          resource: 'person',
          icon: 'mode_edit',
          hidden: true
        },
        component: () => import('./pages/edit')
      },
      {
        path: 'add',
        meta: {
          auth: ['Super Admin'],
          title: 'Add',
          resource: 'person',
          icon: 'add_circle_outline',
          hidden: false
        },
        component: () => import('./pages/add')
      },
      {
        path: 'constant-contact',
        meta: {
          auth: ['Super Admin'],
          title: 'Constant Contact',
          resource: 'person',
          icon: 'email',
          hidden: false
        },
        component: () => import('./pages/constant_contact')
      }
    ].concat(committee, personCommittee, dietOption, personDietOption, emailSubscription, personEmailSubscription, grouping, personEvent, personGrouping)
  }
]
